import PostPrices from './component';

export const initialState = {};
export const reducer = state => state;
export const component = PostPrices;
